import update from 'immutability-helper';
import {
  GET_COMMUNITIES_SUCCESS,
  GET_COMMUNITY_BY_ID_SUCCESS,
  RESET_COMMUNITY_BY_ID_SUCCESS,
  DELETE_COMMUNITY_SUCCESS,
  UPDATE_COMMUNITY_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
  communitiesList: [],
  currentCommunity: '',
};

const communities = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMUNITIES_SUCCESS:
      return update(state, {
        communitiesList: {
          $set: action.payload.communities,
        },
      });
    case GET_COMMUNITY_BY_ID_SUCCESS:
      return update(state, {
        currentCommunity: {
          $set: action.payload.community,
        },
      });
    case RESET_COMMUNITY_BY_ID_SUCCESS:
      return update(state, {
        currentCommunity: {
          $set: '',
        },
      });
    case UPDATE_COMMUNITY_SUCCESS: {
      const communityIndex = state.communitiesList.findIndex(
        (item) => item.id === action.payload.id,
      );

      if (communityIndex !== -1) {
        const newCommunityList = [...state.communitiesList];

        newCommunityList[communityIndex] = action.payload;

        return update(state, {
          currentCommunity: {
            $set: action.payload,
          },
          communitiesList: { $set: newCommunityList },
        });
      } else {
        return update(state, {
          currentCommunity: {
            $set: state.currentCommunity,
          },
          communitiesList: { $set: state.communitiesList },
        });
      }
    }
    case DELETE_COMMUNITY_SUCCESS: {
      const newCommunityList = state.communitiesList.filter((item) => item.id !== action.payload);
      return update(state, {
        currentCommunity: {
          $set: '',
        },
        communitiesList: { $set: newCommunityList },
      });
    }
    default:
      return state;
  }
};

export default communities;
